import React from 'react';
import { Link } from 'react-router-dom';
import {
    Button,
    Form,
    Row,
    Col,
    Select,
    Input,
    DatePicker,
} from 'antd';
const FormItem = Form.Item;
const RangePicker = DatePicker.RangePicker;
import {actions, asyncGet, asyncProvinceGet, exportData} from './reducers';
import { connect } from 'react-redux';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
const spans = {
    xs: 14,
    sm: 14,
    md: 6,
    lg: 6,
    xl: 6,
};

class Search extends React.Component {
    constructor(props) {
        super(props);
    }

    handleReset= () => {
        this.props.form.resetFields();
    }
    // 查询
    handleSearch = () => {
        let values = this.props.form.getFieldsValue();
        for (let i in values) {
            if (values[i] == -1 || values[i] === '' || values[i] === undefined) {
                delete values[i];
            }
        }
        values = formatFormData(values);
        console.log('=====searchValue', values);
        this.props.changeSearchValues(values);
        //this.props.resetPagination();
        this.props.asyncGet();
        this.props.asyncProvinceGet();
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div>
                <h2 style={{ marginBottom: '20px' }}>任务量统计</h2>
                <Form inline={true} onSubmit={this.handleSearch} className="searchWrapper">
                    <Row>
                        <Col span={24} style={{ textAlign: 'center', marginTop: '10px', marginBottom: '20px' }}>
                            <FormItem {...spans} label="时间段">
                                {getFieldDecorator('dateTime')(
                                    <RangePicker
                                        placeholder="选择时间"
                                    />)}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} style={{ textAlign: 'center', marginTop: '10px', marginBottom: '20px' }}>
                            <Button style={{ margin: '0 8px' }} onClick={this.handleReset}>
                                重置
                            </Button>
                            <Button type="primary" onClick={this.handleSearch} style={{ margin: '0 8px' }}>
                                搜索
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    changeSearchValues: values => dispatch(actions.changeSearchValues(values)),
    asyncGet: () => dispatch(asyncGet()),
    asyncProvinceGet:() => dispatch(asyncProvinceGet()),
});
export const formatFormData = values => {
    let result = {};
    Object.keys(values).forEach(key => {
        if (key == 'dateTime') {
            if (typeof values[key] == 'object') {
                values[key].forEach((item, index) => {
                    if (index == 0) {
                        let time = item.valueOf();
                        result['beginTime'] = moment(time).format("YYYY-MM-DD");
                    } else {
                        let time = item.valueOf();
                        result['endTime'] = moment(time).format("YYYY-MM-DD");
                    }
                });
            }
            // result[key] = values[key].valueOf();
        } else if (typeof values[key] !== 'undefined') {
            if (values[key] instanceof moment) {
                result[key] = values[key].valueOf();
            } else {
                result[key] = values[key];
            }
        }
    });
    return result;
};

export default connect(null, mapDispatchToProps)(Form.create()(Search));



// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/taskVolume/search.js